import { render, staticRenderFns } from "./layer-tab.vue?vue&type=template&id=66fd0ce4"
import script from "./layer-tab.vue?vue&type=script&lang=js"
export * from "./layer-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports